import { Popover, PopoverButton, PopoverGroup, PopoverPanel, PopoverBackdrop } from '@headlessui/react'

export type {
  PopoverButtonProps as HeadlessPopoverButtonProps,
  PopoverGroupProps as HeadlessPopoverGroupProps,
  PopoverOverlayProps as HeadlessPopoverOverlayProps,
  PopoverPanelProps as HeadlessPopoverPanelProps,
  PopoverProps as HeadlessPopoverProps
} from '@headlessui/react'

export const HeadlessPopover = Object.assign(Popover, {
  Button: PopoverButton,
  Backdrop: PopoverBackdrop,
  Group: PopoverGroup,
  Panel: PopoverPanel
})
